import { useIntl } from "react-intl";
import { IBudget } from "../../../../models/budgetV2";
import { BudgetRecipient } from "../../enums/budgetRecipient";
import { OccurrenceStepEnum } from "../../../../enums/occurrenceStep";
import { getStatusBadgeClass } from "../../utils/statusHelpers";
import { formatDateTimeWithTimezone } from "../../../../utils/dateUtils";

interface IBudgetOccurrenceListProps {
  budgets: IBudget[];
  loading: boolean;
  profile?: BudgetRecipient;
  currentStep: OccurrenceStepEnum;
  onCreateBudget: () => void;
  onOpenBudget: (budget: IBudget) => void;
}

export const BudgetOccurrenceList = (props: IBudgetOccurrenceListProps) => {
  const intl = useIntl();
  const { budgets, loading, profile, currentStep, onCreateBudget, onOpenBudget } = props;

  const canCreateBudget = profile === BudgetRecipient.CONSULTANT && currentStep === OccurrenceStepEnum.THIRD_DIAGNOSIS;

  return (
    <div className="w-full">
      <div className="text-size-h4 font-bold mb-2">{intl.formatMessage({ id: "intl-msg:budgets.kanban.title" })}</div>
      <div className="text-color-status-resting text-size-14 mb-4">
        {intl.formatMessage({ id: "intl-msg:budgets.occurrenceList.description" })}
      </div>

      {canCreateBudget && (
        <div className="mb-8">
          <button type="button" className="btn btn-primary px-20" onClick={onCreateBudget}>
            {intl.formatMessage({ id: "intl-msg:budgets.new" })}
          </button>
        </div>
      )}

      {loading ? (
        <div className="animate-pulse rounded bg-gray-200 h-[120px] w-full" />
      ) : budgets.length === 0 ? (
        <div className="text-color-status-resting text-size-14">
          {intl.formatMessage({ id: "intl-msg:budgets.occurrenceList.empty" })}
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {budgets.map((budget) => (
            <div
              key={budget.uuid}
              className="border border-gray-200 rounded-md p-4 hover:bg-gray-50 transition-colors cursor-pointer"
              onClick={() => onOpenBudget(budget)}
            >
              <div className="flex justify-between items-center mb-2">
                <span className="font-bold">
                  {intl.formatMessage({ id: "intl-msg:budgets.title" })} {budget.number}
                </span>
                <span className="text-size-12 text-gray-500">v{budget.lastVersionNumber}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-size-14 text-gray-600">{budget.recipientLabel}</span>
                <span className={`px-3 py-1 rounded-full text-size-12 ${getStatusBadgeClass(budget.statusLabel || "")}`}>
                  {budget.statusLabel}
                </span>
              </div>
              <div className="text-size-12 text-gray-500 mt-1">
                {budget.updatedAt ? formatDateTimeWithTimezone(budget.updatedAt) : "-"}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
